<template>
  <div class="situazione-ordini" :key="appName">
    <div class="row row-custom">
      <div class="titolo-app col-xl-11 col-lg-8 col-1 no-padding">
        <span class="titolo-bold d-none d-lg-block">
          {{ $t('situazioneOrdini.situazioneOrdini').toUpperCase() }}
        </span>
      </div>

      <div class="icone col-xl-13 col-lg-16 col-23 no-padding" v-show="showIcone">

        <div class="icona" v-if="!showNuovo"></div>

        <div class="icona" v-if="(!showNuovo && !ifGoToClausole && !ifGoToDettaglio)"></div>

        <div class="icona" @click="goToOrdini">
          <div class="icona-menu">
            <icon name="riv-lista" scale="1.5"></icon>
          </div>
          <div class="label-menu no-padding">
            <span v-html="$t('situazioneOrdini.listaOrdini')"></span>
          </div>
        </div>
        <div class="icona" @click="goToClausole" v-if="ifGoToClausole">
          <div class="icona-menu clausole-icona">
            <icon name="riv-clausole" scale="1.5"></icon>
          </div>
          <div class="label-menu no-padding clausole-label">
            {{ $t('situazioneOrdini.clausole') }}
          </div>
        </div>
        <div class="icona" @click="goToDettaglio" v-if="ifGoToDettaglio">
          <div class="icona-menu clausole-icona">
            <icon name="riv-clausole" scale="1.5"></icon>
          </div>
          <div class="label-menu no-padding">
            <span v-html="$t('situazioneOrdini.dettaglio')"></span>
          </div>
        </div>
        <div class="icona" @click="goToNuovoBuono" v-if="showNuovo"
                        :style="[(showBorder === true) ? {borderBottom: '1px solid #007c74'} : {borderBottom: '0px'}]">
          <div class="icona-menu">
            <icon name="riv-ticket" scale="1.5"></icon>
          </div>
          <div class="label-menu no-padding">
            <span v-html="$t('situazioneOrdini.nuovoBuono')"></span>
          </div>
        </div>
      </div>

    </div>

    <div id="contenitore-situazioneordini" class="contenitore col-24 no-padding"
         :style="{ height: contenitoreHeight + 'px', overflowY: (showScroll) ? 'auto' : 'hidden' }">
      <keep-alive>
        <router-view @hideScroll="hideScroll" @showScroll="showScroll = true" @setShowNuovo="setShowNuovo" :prefixApp="prefixApp"></router-view>
      </keep-alive>
    </div>

    <el-dialog class="clausoleDialog" :title="$t('situazioneOrdini.clausole').toUpperCase()"
               :visible.sync="showClausole" :append-to-body="true"
               custom-class="custom-dialog offset-xl-7 col-xl-10 offset-lg-6 col-lg-12 offset-md-4 col-md-16 offset-sm-2 col-sm-20 offset-1 col-22">

      <div class="contenuto">
        <div class="clausola" v-for="(item, index) in clausole.clausole" :key="index">
          <span>
            {{ item.desClau }}
          </span>
        </div>
      </div>

      <el-pagination v-if="(clausole.nrPages > 1)" :current-page="clausole.currentPage"
                     background class="custom-pagination"
                     layout="prev, pager, next"
                     :total="clausole.nrItems"
                     :page-size="clausole.pag_for"
                     @current-change="changePage">
      </el-pagination>

    </el-dialog>

  </div>
</template>

<script>
  import {bus} from '@/components/Bus.js'

  export default {
    name: 'SituazioneOrdini',
    props: {
      contenitoreHeight: {
        type: Number,
        required: true,
        default: 550
      },
      appName: {
        type: String
      }
    },
    i18n: {
      messages: {
        it_IT: {
          situazioneOrdini: {
            listaOrdini: 'Lista<br>Ordini',
            clausole: 'Clausole',
            nuovoBuono: 'Nuovo<br>Buono di Ritiro',
            situazioneOrdini: 'Situazione Ordini',
            dettaglio: 'Dettaglio<br>Ordine'
          }
        },
        fr_FR: {
          situazioneOrdini: {
            listaOrdini: 'Liste<br>Commandes',
            clausole: 'Clauses',
            nuovoBuono: 'Nouveau<br>Coupon de Collection',
            situazioneOrdini: 'Situation de Commande',
            dettaglio: 'Détail<br>Commande'
          }
        },
        es_ES: {
          situazioneOrdini: {
            listaOrdini: 'Lista<br>Pedidos',
            clausole: 'Cláusulas',
            nuovoBuono: 'Nuevo<br>Aviso de Retirada',
            situazioneOrdini: 'Situación de Pedidos',
            dettaglio: 'Detalle<br>Orden'
          }
        },
        de_DE: {
          situazioneOrdini: {
            listaOrdini: 'Auftragsliste',
            clausole: 'Klauseln',
            nuovoBuono: 'Neuer<br>Sammelcoupon',
            situazioneOrdini: 'Bestellsituation',
            dettaglio: 'Bestelldetails'
          }
        },
        en_GB: {
          situazioneOrdini: {
            listaOrdini: 'List<br>Orders',
            clausole: 'Clauses',
            nuovoBuono: 'New<br>Collection Coupon',
            situazioneOrdini: 'Order situation',
            dettaglio: 'Order<br>Detail'
          }
        }
      }
    },
    data () {
      return {
        prefixApp: '',
        codLang: sessionStorage.getItem('codLang'),
        showScroll: true,
        showClausole: false,
        showNuovo: false,
        clausole: {
          clausole: [],
          pag_for: 25,
          currentPage: 1,
          nrPages: 0,
          nrItems: 0
        }
      }
    },
    watch: {
      appName: function (newVal, oldVal) {
        if (!this._inactive) {
          this.initialize()
        }
      }
    },
    beforeMount: function () {
      this.initialize()
      if (this.$route.path === '/fornitura/situazioneordini/nuovo') {
        this.$set(this, 'showNuovo', true)
      }
    },
    computed: {
      showIcone: function () {
        let path = this.$route.path
        return (path.indexOf('/ordini') === -1)
      },
      showBorder: function () {
        let path = this.$route.path
        return (path.indexOf('/nuovo') >= 0)
      },
      ifGoToClausole: function () {
        let path = this.$route.path
        return (path.indexOf('/dettaglio') >= 0)
      },
      ifGoToDettaglio: function () {
        let path = this.$route.path
        return (path.indexOf('/nuovo') >= 0)
      }
    },
    methods: {
      initialize: function () {
        let tree = this.$route.matched
        let appName = tree[2].meta.appName
        if (appName === 'WebBuoniDiRitiro') {
          this.prefixApp = 'BdR'
        } else if (appName === 'SituazioneOrdini') {
          this.prefixApp = 'SO'
        }
        this.$nextTick(() => {
          bus.$on('changeLanguage', () => {
            this.codLang = sessionStorage.getItem('codLang')
          })
        })
      },
      setShowNuovo: function (val) {
        this.$set(this, 'showNuovo', val)
      },
      changePage: function (page) {
        this.$set(this.clausole, 'currentPage', page)
        this.getClausole()
      },
      hideScroll: function () {
        let container = this.$el.querySelector('#contenitore-situazioneordini')
        container.scrollTop = 0
        this.$set(this, 'showScroll', false)
      },
      goToClausole: function () {
        this.getClausole()
      },
      goToDettaglio: function () {
        this.$router.push({name: this.prefixApp + 'DettaglioOrdine'})
      },
      goToOrdini: function () {
        this.$router.push({name: this.prefixApp + 'Ordini'})
      },
      goToNuovoBuono: function () {
        this.$router.push({name: this.prefixApp + 'NuovoBuono'})
      },
      getClausole: function () {
        let ordine = JSON.parse(sessionStorage.getItem(this.prefixApp + '_ordine'))
        this.$http.get('situazioneordini/' + this.prefixApp.toLowerCase() + '/clausole', {
          params: {
            codLang: this.codLang,
            country: ordine.country,
            codForn: ordine.codForn,
            codSoc: ordine.codSoc,
            codMag: ordine.codMag,
            annoOrd: ordine.annoOrd,
            numOrd: ordine.numOrd,
            pag_action: (this.clausole.currentPage > 1) ? 'NEXT' : 'BEGIN',
            pag_from: this.clausole.currentPage,
            pag_for: this.clausole.pag_for
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'showClausole', true)
              this.$set(this.clausole, 'nrPages', parseInt(response.body.attrib.pages))
              this.$set(this.clausole, 'nrItems', parseInt(response.body.attrib.size))
              this.$set(this.clausole, 'clausole', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .clausoleDialog {
    .el-dialog__body {
      .contenuto {
        margin-bottom: 20px;
        padding: 0 10px;
        .clausola {
          .set-font(@size: 13px; @color: #454848);
        }
      }
    }
  }

  .situazione-ordini {
    .titolo-app {
      padding-left: 5px;
      .set-font(@size: 15px, @color: @greenRiva);
      letter-spacing: 2px;
      overflow: hidden;
      height: 50px;
      line-height: 50px;
      .titolo-bold {
        font-weight: 700;
      }
    }
    .icone {
      padding-top: 8px;
      padding-bottom: 8px;
      text-align: right;
      .icona:hover {
        cursor: pointer;
      }
      .icona {
        text-align: center;
        width: 170px;
        display: inline-block;
      }
      .icona-menu {
        padding-top: 2px;
        padding-left: 0;
        padding-right: 3px;
        text-align: right;
        display: inline-block;
        vertical-align: middle;
      }
      .label-menu {
        .set-font(@size: 13px; @family: 'os-semibold');
        text-align: center;
        display: inline-block;
        vertical-align: middle;
        line-height: 17px;
      }
      .clausole-label {
        line-height: 28px;
      }
    }
    .contenitore {
      -webkit-box-shadow: 0 0 10px 2px #cecece;
      -moz-box-shadow: 0 0 10px 2px #cecece;
      box-shadow: 0 0 10px 2px #cecece;
      background-color: #ffffff;
      margin: auto;
      overflow-x: hidden;
      overflow-y: auto;
      border-radius: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Fornitura/SituazioneOrdini/SituazioneOrdini.vue